import { createEmptyResources, type ResourceSnapshot } from "@/game/model/resources";

export type GeneratorId = "breath" | "journal";

export type GeneratorState = {
  id: GeneratorId;
  level: number;
};

export type IdleState = {
  resources: ResourceSnapshot;
  generators: GeneratorState[];
  /** Passive focus per second from generators + base. */
  focusPerSecond: number;
  /** Bonus from active clicks. */
  clickPower: number;
  totalClicks: number;
  lastTickAt: number;
  createdAt: number;
};

export function createInitialIdleState(now = Date.now()): IdleState {
  return {
    resources: createEmptyResources(),
    generators: [
      { id: "breath", level: 1 },
      { id: "journal", level: 0 },
    ],
    focusPerSecond: 0.5,
    clickPower: 1,
    totalClicks: 0,
    lastTickAt: now,
    createdAt: now,
  };
}
